export default "__VITE_ASSET__B29atmy1__"